__turbopack_context__.v({
  "className": "syncopate_329a73b1-module__sDejKa__className",
  "variable": "syncopate_329a73b1-module__sDejKa__variable",
});
